import React from 'react';
import Icon from '../../../components/AppIcon';

const TabNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'employees',
      label: 'مدیریت کارکنان',
      icon: 'Users',
      description: 'مدیریت اطلاعات و برنامه کاری کارکنان',
    },
    {
      id: 'services',
      label: 'مدیریت خدمات',
      icon: 'LayoutGrid',
      description: 'تنظیم خدمات، قیمت و مدت زمان',
    },
    {
      id: 'calendar',
      label: 'تقویم دسترسی',
      icon: 'Calendar',
      description: 'برنامه‌ریزی زمان‌بندی و دسترسی',
    },
    {
      id: 'client',
      label: 'مدیریت مشتریان',
      icon: 'User',
      description: 'مدیریت اطلاعات و تاریخچه مشتریان',
    },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-1">
      <div className="flex flex-col sm:flex-row gap-1">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`
              flex-1 flex items-center gap-3 px-4 py-3 rounded-md text-right transition-all duration-200
              ${
                activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-foreground hover:bg-muted'
              }
            `}>
            <Icon
              name={tab?.icon}
              size={20}
              color={activeTab === tab?.id ? 'currentColor' : 'currentColor'}
            />
            <div className="flex-1 text-right">
              <div className="text-sm font-medium">{tab?.label}</div>
              <div className="text-xs opacity-75 mt-0.5 hidden sm:block">
                {tab?.description}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
